import { selectAppSettings } from 'providers/AppSettings/store/selectors'
import { selectComponents } from 'components/store'

export const selectBody = (store) => selectComponents(store).body

if (!selectAppSettings) throw new Error('selectAppSettings is null')

export const selectBodyAppSettings = (store) => selectAppSettings(store).Body
